"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Header = function Header(_ref) {
  var bundleName = _ref.bundleName;
  var history = (0, _reactRouterDom.useHistory)();
  var _useConfig = (0, _useConfig2.default)(),
    backUrl = _useConfig.backUrl;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 'auto'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    name: "arrow-left",
    appearance: "primary",
    size: "5",
    onClick: function onClick() {
      return history.push(backUrl);
    },
    dataAttributes: {
      'data-testid': 'back-arrow'
    }
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center",
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': 'bundle-name'
    },
    justify: "center",
    size: 3,
    text: bundleName,
    weight: 1
  }))));
};
Header.propTypes = {
  bundleName: _propTypes.default.string
};
var _default = Header;
exports.default = _default;